import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import type { Column } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface DataTableColumnHeaderProps<TData, TValue> extends React.HTMLAttributes<HTMLDivElement> {
  column: Column<TData, TValue>;
  title: string;
  align?: 'left' | 'right' | 'center';
}

export function DataTableColumnHeader<TData, TValue>({
  column,
  title,
  align = 'left',
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return (
      <span
        className={cn(
          'text-xs font-medium uppercase tracking-wider text-muted-foreground',
          className,
        )}
      >
        {title}
      </span>
    );
  }
  const sort = column.getIsSorted();
  return (
    <Button
      variant="ghost"
      size="sm"
      className={cn(
        '-ml-3 h-7 gap-1.5 text-xs font-medium uppercase tracking-wider text-muted-foreground hover:text-foreground data-[state=open]:bg-accent',
        align === 'right' && 'ml-auto -mr-3 flex-row-reverse',
        className,
      )}
      onClick={() => column.toggleSorting(sort === 'asc')}
    >
      <span>{title}</span>
      {sort === 'asc' ? (
        <ArrowUp className="size-3.5" />
      ) : sort === 'desc' ? (
        <ArrowDown className="size-3.5" />
      ) : (
        <ChevronsUpDown className="size-3.5 opacity-50" />
      )}
    </Button>
  );
}
